import React, { useState } from "react";
import ReactMarkdown from "react-markdown";
import { ChevronUp, ChevronDown } from "react-feather";
import { useLocalization } from "@fluent/react";
import { translateFaqQuestions } from "byzantine/src/l10n/SettingLocalizers";
import type {
  SupportFaqCategory,
  SupportFaqQuestion,
} from "byzantine/src/types/SettingLocalizers.types";

function FAQQuestion({ question, answer }: SupportFaqQuestion) {
  return (
    <div>
      <div className="faq-question-text">{question}</div>
      <div className="faq-answer-text">
        <ReactMarkdown>{answer}</ReactMarkdown>
      </div>
    </div>
  );
}

type FAQCategoryProps = {
  categoryName: string;
  faqs: SupportFaqQuestion[];
};

function FAQCategory({ categoryName, faqs }: FAQCategoryProps) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="faq-category">
      <div
        role="button"
        tabIndex={0}
        className="faq-category-header"
        onKeyUp={({ key }) => {
          if (key === "Enter" && isOpen) {
            setIsOpen(!isOpen);
          }
        }}
        onClick={() => {
          setIsOpen((open) => !open);
        }}
      >
        <div className="card-title">{categoryName}</div>
        <div>{isOpen ? <ChevronUp /> : <ChevronDown />}</div>
      </div>
      {isOpen ? (
        <div>
          {faqs.map((faq) => (
            <FAQQuestion
              key={faq.question}
              question={faq.question}
              answer={faq.answer}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
}

type FAQListProps = {
  categories: SupportFaqCategory[];
};

export default function FAQList({ categories }: FAQListProps) {
  const { l10n } = useLocalization();
  const translatedCategories = translateFaqQuestions(categories, l10n);
  return (
    <div className="faq-list">
      <div className="support-section-title">
        {l10n.getString("heading-faq")}
      </div>
      <div className="card">
        {translatedCategories.map((faqCategory) => (
          <FAQCategory
            key={faqCategory.category}
            categoryName={faqCategory.category}
            faqs={faqCategory.questions}
          />
        ))}
      </div>
    </div>
  );
}
